import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { PAGES, COMPONENTS } from '../../config/pagePaths.generated.js';
import { filterLinksByRole } from '../../utils/rbacUtils.js';

// Quick actions. Each carries the gate its target enforces (same shape as a nav link: pagePath, componentPath,
// minLevel), so the palette only offers what the user can actually do.
export const COMMAND_PALETTE_ACTIONS = [
    {
        id: 'action-new-game',
        label: 'Create New Game',
        subtitle: 'Set up a new game in Game Management',
        icon: <FontAwesomeIcon icon={faPlus} />,
        path: '/admin-settings/game-mgmt/games',
        pagePath: PAGES.GAMES,
        componentPath: COMPONENTS.GAMES_CREATE_GAME,
        minLevel: 'FULL_ACCESS',
    },
    {
        id: 'action-invite-user',
        label: 'Invite User',
        subtitle: 'Send an invitation to a teammate',
        icon: <FontAwesomeIcon icon={faUserPlus} />,
        path: '/admin-settings/user-mgmt',
        pagePath: PAGES.USER_MGMT,
        componentPath: COMPONENTS.USER_MGMT_INVITE_USER,
        minLevel: 'FULL_ACCESS',
    },
];

/** The actions this user may take - none until permissions load. */
export const visibleActions = (actions, userRole, effectivePermissions) =>
    (effectivePermissions ? filterLinksByRole(actions, userRole, effectivePermissions) : []);

export function useCommandPaletteActions() {
    const userRole = useSelector(state => state.dashboardContext?.userRole);
    const effectivePermissions = useSelector(state => state.effectivePermissions);
    return useMemo(
        () => visibleActions(COMMAND_PALETTE_ACTIONS, userRole, effectivePermissions),
        [userRole, effectivePermissions],
    );
}
